import * as React from 'react';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { ResultType } from '@domain/constant/resultType';
import classNames from 'classnames/bind';
import styles from './applyStatusTitle.module.scss';

const cx = classNames.bind(styles);

const titleText = (resultType: ResultType) => {
  switch (resultType) {
    case 'VERY_GOOD':
      return 'Very Good';
    case 'GOOD':
      return 'Good';
    case 'CHEER_UP':
      return 'Cheer Up';
  }
};

const contentText = (resultType: ResultType) => {
  switch (resultType) {
    case 'VERY_GOOD':
      return (
        <>
          응시 목표나 방법을 잘 이해했어요!
          <br />
          그대로 활용해도 좋아요!
        </>
      );
    case 'GOOD':
      return (
        <>
          응시 목표나 방법을 충분히 이해했어요!
          <br />
          아쉬운 부분은 없었는지 확인해 보고,
          <br />한 번 더 응시를 해보셔도 좋아요!
        </>
      );
    case 'CHEER_UP':
      return (
        <>
          응시 목표나 방법을 잘 이해하고 있는지
          <br />
          점검해 보세요!
          <br />
          응시 방법을 잘 숙지한 후 다시 한번
          <br />
          응시해 보세요!
        </>
      );
  }
};

interface ApplyStatusTitleProps {
  applyResult: PaccApplyResultVO;
}

const ApplyStatusTitle = ({ applyResult }: ApplyStatusTitleProps) => {
  if (!applyResult) return null;

  const { resultType, userName } = applyResult;

  return (
    <div className={cx('textArea')}>
      <strong className={cx('titleText')}>
        {userName}님의
        <br />
        종합응시결과: {titleText(resultType)}
      </strong>
      <p className={cx('subTitleText')}>{contentText(resultType)}</p>
    </div>
  );
};

export default ApplyStatusTitle;
